<mat-spinner diameter="30"></mat-spinner>
<span>
  <ng-content/>
</span>
